import React from "react";
import styles from "./ContactItem.module.css";

const ContactItem = () => {
  return (
    <div className={styles.contactCtn}>
      <div className={styles.contactData} id="contact">
        <h3>Want to work together?</h3>
        <p>Contact me to discuss your next project</p>
        <button className={styles.btnContact}>
          <a href="mailto:greco.guido@hotmail.com?subject=Project/Job Proposition">
            Let's talk
          </a>
        </button>
      </div>
    </div>
  );
};

export default ContactItem;
